import { initDatadogRum } from 'vendor/datadog/rum/init';
import { initDatadogLogs } from 'vendor/datadog/logs/init';

const rumEnabled = import.meta.env.VITE_DATADOG_RUM_ENABLED === 'true';
const logsEnabled = import.meta.env.VITE_DATADOG_LOGS_ENABLED === 'true';

export function initDatadog() {
  const clientToken = import.meta.env.VITE_DATADOG_CLIENT_TOKEN;
  const site = import.meta.env.VITE_DATADOG_SITE || 'datadoghq.com';
  const service = import.meta.env.VITE_DATADOG_SERVICE || 'webapp';
  const env =
    import.meta.env.VITE_DATADOG_ENV ||
    import.meta.env.VITE_NODE_ENV ||
    'development';

  if (!clientToken) {
    console.warn('Datadog is enabled but VITE_DATADOG_CLIENT_TOKEN is not set');
    return;
  }

  if (rumEnabled) {
    const applicationId = import.meta.env.VITE_DATADOG_APPLICATION_ID;
    if (!applicationId) {
      console.warn(
        'Datadog RUM is enabled but VITE_DATADOG_APPLICATION_ID is not set'
      );
    } else {
      initDatadogRum({ applicationId, clientToken, site, service, env });
    }
  }

  if (logsEnabled) {
    initDatadogLogs({ clientToken, site, service, env });
  }
}
